import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Main from "./containers/Main";

function App() {
  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
